import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import styles from './Balloon.scss';

const Balloon = onClickOutside(
  class extends Component {
    handleClickOutside = () => {
      this.props.hide();
    };

    render() {
      const { children, onEmployee, style } = this.props;

      return (
        <div style={style} className={`${styles.balloonWrap} ${onEmployee ? 'employee_pdf' : null}`}>
          <div className="balloon">{children}</div>
        </div>
      );
    }
  }
);

export default Balloon;
